define('views/demo-dialog',['require','mediator','views/dialog'],function(require) {
    'use strict';

    function DemoDialog() {
    }

    DemoDialog.isDemo = function(){
        var mediator = require('mediator');
        return mediator.isDemo();
    };

    DemoDialog.show = function() {
        var Dialog = require('views/dialog');
        Dialog.show('Демо', 'Эта функция недоступна в демо режиме.', Dialog.Buttons.Close);
    };

    return DemoDialog;
});

